import { DetailRow, DetailRowItem } from '@/components/play/DetailRowItem'

export function DetailGrid({ rows }: { rows: DetailRow[] }) {
	const leftRows = rows.filter((_, index) => index % 2 === 0)
	const rightRows = rows.filter((_, index) => index % 2 === 1)

	return (
		<div className='grid gap-0 sm:grid-cols-2'>
			<div className='flex flex-col sm:border-r sm:border-border'>
				{leftRows.map((row) => (
					<DetailRowItem key={row.label} {...row} />
				))}
			</div>
			<div className='flex flex-col'>
				{rightRows.map((row) => (
					<DetailRowItem key={row.label} {...row} />
				))}
			</div>
		</div>
	)
}
